import React from 'react';
import { Button } from 'reactstrap';

export interface ChoiceChip<T extends string | number> {
  value: T;
  /** The text of the chip; it may hold a small drawing before the words (the waveform shapes). */
  label: React.ReactNode;
  disabled?: boolean;
}

interface ChoiceChipsProps<T extends string | number> {
  label: string;
  options: ReadonlyArray<ChoiceChip<T>>;
  value?: T;
  onChange: (value: T) => void;
}

/** A row of radio chips for one step-3 choice (moment, shape, length; designs n1–n3). */
export function ChoiceChips<T extends string | number>({ label, options, value, onChange }: ChoiceChipsProps<T>) {
  return (
    <div className="d-flex flex-wrap gap-2" role="radiogroup" aria-label={label}>
      {options.map((option) => (
        <Button
          key={option.value}
          type="button"
          role="radio"
          size="sm"
          color="primary"
          outline={option.value !== value}
          aria-checked={option.value === value}
          disabled={option.disabled === true}
          onClick={() => onChange(option.value)}
        >
          {option.label}
        </Button>
      ))}
    </div>
  );
}
